import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';
import { CookieProvider } from './components/CookieContext';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <CookieProvider>
          <App />
        </CookieProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>
);